import { useState, useEffect} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

function NavBar(){
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Cerrar menú móvil al navegar
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const handleLogoClick = () => {
    navigate("/");
  };

  const isActive = (route) => {
    return location.pathname === route;
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo" onClick={handleLogoClick} style={{cursor: 'pointer'}}>
          <h1>
            Branch<span> /{" >"} development</span>
          </h1>
        </div>

        <button 
          className="mobile-menu-toggle" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={mobileMenuOpen ? "open" : ""}></span>
          <span className={mobileMenuOpen ? "open" : ""}></span>
          <span className={mobileMenuOpen ? "open" : ""}></span>
        </button>

        <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <ul>
            <li>
              <Link to="/about" className={isActive("/about") ? "active" : ""}>
                Sobre Nosotros
              </Link>
            </li>
            <li>
              <Link to="/pdf-editor" className={isActive("/pdf-editor") ? "active" : ""}>
                openPDF
              </Link>
            </li>
            <li>
              <Link to="/contacto" className={isActive("/contacto") ? "active" : ""}>
                Contáctanos
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
export default NavBar;